import { VISIT_TYPE_IN_PERSON_VALUE } from '@/views/constants'

export default {
  // If we change the defaults, update types.RESET_FORM_DATA mutation
  formData: {
    isTelehealth: VISIT_TYPE_IN_PERSON_VALUE,
    areUserThePatient: null
  }
}
